<div class="autocomplete" ngxClickElsewhere (clickElsewhere)="isListVisible = false">
    <div class="input-icon">
        <input [(ngModel)]="searchTerm" 
               class="form-control" 
               type="text"
               [ngModelOptions]="{standalone: true}"
               (keyup)="getAllItems()"
               placeholder="Pretraži">
        <div class="input-icon-addon">
            <i class="fe fe-search"></i>
        </div>
    </div>

    <div class="autocomplete__list" *ngIf="isListVisible">
        <div class="autocomplete__item"
             *ngFor="let item of items; trackBy: trackByFn"
             (click)="onSelect(item)">
            {{ item.name }}
        </div>
    </div>
</div>